export const index = function ({ dispatch, commit }, payload) {
  const data = {};
  data.url = "get_products";
  data.loading = "get_index";
  data.method = "GET";
  data.data = payload;
  return dispatch("axiosWeb", data, { root: true })
    .then((response) => {
      commit("setIndex", response.data);
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const checkout = function ({ dispatch, commit }, payload) {
  const data = {};
  data.url = "bestellen";
  data.method = "POST";
  data.data = payload;
  return dispatch("axiosWeb", data, { root: true })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
